import type { BackorderRow } from '@eombor/contracts';

/**
 * BELGILASH — qaysi bildirgilarni bitta talabnomaga qo'shsa bo'ladi.
 *
 * Talabnomada BITTA ombor va BITTA buyurtmachi bor — bu ustunlar, tanlov
 * emas. Shuning uchun birinchi belgilangan ariza QOZIQ bo'lib qoladi va
 * unga mos kelmaydigan qatorlarning katakchasi o'chadi.
 *
 * Qoida serverda ham bor (`assertMergeable`); bu yerdagi nusxa faqat
 * katakchani o'chiradi. Ekran yumshoqroq bo'lsa, skladchi o'nta belgilab,
 * xatoni faqat tugmani bosgandan keyin ko'rardi.
 */
export interface BackorderSelection {
  has: (row: BackorderRow) => boolean;
  /** Katakcha ko'rinadimi va bosiladimi. */
  canPick: (row: BackorderRow) => boolean;
  toggle: (row: BackorderRow) => void;
}

/**
 * Qatorni QOZIQ bilan bir talabnomaga qo'shsa bo'ladimi.
 *
 * Qoziq yo'q bo'lsa (hali hech nima belgilanmagan) — qabul qilingan
 * har qanday ariza ochiq: birinchi bosilgani qoziqni o'zi belgilaydi.
 */
export const mergeableWith = (
  anchor: BackorderRow | undefined,
  row: BackorderRow,
): boolean => {
  if (row.status !== 'ACCEPTED') return false;
  if (anchor === undefined) return true;
  return row.warehouseId === anchor.warehouseId && row.requesterUserId === anchor.requesterUserId;
};

/** Belgilanganlarning BIRINCHISI — ro'yxat tartibida, qoziq shu. */
export const anchorOf = (
  rows: readonly BackorderRow[],
  picked: ReadonlySet<string>,
): BackorderRow | undefined => rows.find((row) => picked.has(row.id));

/**
 * Belgilanganlarni ro'yxat TARTIBIDA qaytaradi.
 *
 * `Set` ning tartibi bosilish ketma-ketligi bo'ladi, talabnoma satrlari
 * esa skladchi ekranda ko'rgan tartibda raqamlanishi kerak.
 */
export const pickedRows = (
  rows: readonly BackorderRow[],
  picked: ReadonlySet<string>,
): BackorderRow[] => rows.filter((row) => picked.has(row.id));
